import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_account_details = (id) => {
  // 后端使用POST方法，参数从Body JSON传递
  return api.post(`${ApiEndpointConstants.GETACCOUNTDETAILS}`, {
    id,
  });
};
